// src/components/Login.jsx
import React, { useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { apiUrl } from "../config/api";

function Login() {
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (!formData.username.trim() || !formData.password) {
        throw new Error("نام کاربری و رمز عبور الزامی است");
      }

      const response = await fetch(apiUrl("/api/admin/login"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      // بررسی content-type
      const contentType = response.headers.get("content-type");
      if (!contentType || !contentType.includes("application/json")) {
        const text = await response.text();
        console.error("پاسخ سرور (غیر JSON):", text);
        throw new Error("خطای سرور. لطفاً بعداً تلاش کنید");
      }

      const data = await response.json();
      console.log("پاسخ کامل سرور:", data); // لاگ برای دیباگ

      if (!response.ok) {
        throw new Error(data.message || "نام کاربری یا رمز عبور اشتباه است");
      }

      // بررسی وجود توکن
      if (!data.token) {
        throw new Error("توکن توسط سرور ارسال نشد");
      }

      // ذخیره توکن و اطلاعات
      localStorage.setItem("adminToken", data.token);
      localStorage.setItem("adminUser", JSON.stringify(data.admin));
      
      console.log("توکن ذخیره شد:", data.token);
      console.log("کاربر ذخیره شد:", data.admin);

      toast.success(data.message || "ورود موفقیت‌آمیز بود!");
      
      // ریدایرکت
      navigate("/admin");
      
    } catch (error) {
      console.error("خطای لاگین:", error);
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">🔐</div>
          <h2>پنل مدیریت</h2>
          <p>برای ورود اطلاعات حساب خود را وارد کنید</p>
        </div>
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label>نام کاربری</label>
            <div className="input-wrapper">
              <span className="input-icon">👤</span>
              <input
                type="text"
                name="username"
                value={formData.username}
                onChange={handleChange}
                placeholder="نام کاربری خود را وارد کنید"
                autoComplete="username"
                required
              />
            </div>
          </div>
          <div className="form-group">
            <label>رمز عبور</label>
            <div className="input-wrapper">
              <span className="input-icon">🔒</span>
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="رمز عبور خود را وارد کنید"
                autoComplete="current-password"
                required
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? "🙈" : "👁️"}
              </button>
            </div>
          </div>
          <button
            type="submit"
            disabled={loading}
            className="login-btn"
          >
            {loading ? (
              <>
                <span className="spinner"></span>
                در حال ورود...
              </>
            ) : (
              <>
                <span>🚀</span>
                ورود به پنل مدیریت
              </>
            )}
          </button>
        </form>
        <div className="login-footer">
          <a href="/">← بازگشت به صفحه اصلی</a>
        </div>
      </div>
    </div>
  );
}

export default Login;
